module.exports = __webpack_public_path__ + "img/head.a139be89.png";